export const AUTOMATION_TRIGGER_ICON_MAP = {
    "inactivity": "ui-ghost",
    "new_order": "ui-package-plus",
    "order_status_change": "ui-refresh-cw-02",
    "product_group_stock": "ui-alert-circle",
    "too_long_on_external_status": "ui-package-search",
    "periodic": "ui-calendar-check-02",
    "client_date": "ui-calendar",
    "specific_date": "ui-announcement-02",
    "data_filled": "ui-users-check",
    "feedback_received": "ui-message-check-square",
    "coupon_expiring": "ui-sale-03",
    "reward_reached": "ui-award-04",
    "reward_used": "ui-award-01",
    "custom_event": "ui-check-done-02",
    "custom_event_without_order": "ui-cursor-box",
    "birthday": "ui-cake",
    "manual": "ui-cursor-click-01",
    "joined_segment": "ui-users-left",
    "left_segment": "ui-users-right",
    "enter_stage": "ui-users-up",
    "new_quotation": "ui-bank-note-01",
    "quotation_expired": "ui-credit-card-x",
    "quotation_status_change": "ui-credit-card-refresh",
    "quotations_too_long_status": "ui-credit-card-lock",
    "quotation_without_order": "ui-clock-snooze",
    "too_long_on_status": "ui-clock-snooze",
};

export function getAutomationIcon(item, triggerKey = 'trigger_type') {
    if (item.type === 'campaign' || item.automation_type === 'campaign') {
        return 'ui-announcement-02';
    }
    const trigger = item[triggerKey] || item.automation_trigger || item.trigger_type;
    return AUTOMATION_TRIGGER_ICON_MAP[trigger]
        || ((item.type === 'robot' || item.automation_type === 'robot')
            ? 'ui-message-chat-square'
            : 'ui-file-02');
}
